<template>
  <div class="package-documents-selection">
    <div class="package-documents-selection">
      <v-expansion-panels>
        <accordion-templates-group
          v-for="category in categoriesWithTemplates"
          v-bind:key="category.categoryId"
          v-bind:group="category"
          v-bind:selected-templates="value"
          v-on:template-toggle="onTemplateToggle"
        />
      </v-expansion-panels>
      <button
        class="document-templates__create-package-btn
          document-templates__create-package-btn--narrow"
        :title="buttonTitle"
        type="button"
        v-bind:disabled="!isSelectedTemplatesEnough"
        v-on:click="onClickSavePackage"
      >
        Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { List } from 'monet';
import AccordionTemplatesGroup from './AccordionTemplatesGroup.vue';

/**
 * @description Минимальное количество выбранных шаблонов для формирования шаблонного
 * Пакета документов/контрактов
 * @type {number}
 */
const MIN_SELECTED_TEMPLATES_COUNT = 2;

/**
 * @description Название события добавления/удаления шаблона из Пакета
 * @type {string}
 */
const EMIT_CLICK_ADD_OR_DEL_PACKAGE_TEMPLATE = 'template-toggle';

/**
 * @description Название события сохранения Пакета
 * @type {string}
 */
const EMIT_CLICK_ON_SAVE_PACKAGE_BUTTON = 'save-package';
export default {
  /**
   * @description Компонент формы редактирования шаблона документа клиники.
   */
  name: 'FormEditClinicPackageTemplate',
  components: { AccordionTemplatesGroup },
  computed: {
    /**
     * @description Проверка, достаточно ли шаблонных документов/контрактов выбрал пользователь
     * для перехода на третий этап создания Пакета?
     * @type {boolean}
     */
    isSelectedTemplatesEnough() {
      return this.value.size() >= MIN_SELECTED_TEMPLATES_COUNT;
    },

    /**
     * @description Данный метод отвечает за отображения текста, при наведении на кнопку Далее
     * на втором этапе. Сам текст зависит количества выбранных пользователем шаблонов документов.
     * @return {string}
     */
    buttonTitle() {
      return this.isSelectedTemplatesEnough
        ? 'Сохранить'
        : 'Необходимо выбрать минимум 2 шаблона';
    },
  },
  methods: {
    /**
     * @description Обработать выбор/снятие шаблона.
     * @param {string} templateName
     * @param {string} templateType
     * @param {string} templateId
     * @param {boolean} isTemplateSample
     * @param {boolean} checked
     * @returns {void}
     */
    onTemplateToggle(templateName, templateType, templateId, isTemplateSample, checked) {
      this.$emit(
        EMIT_CLICK_ADD_OR_DEL_PACKAGE_TEMPLATE,
        templateName,
        templateType,
        templateId,
        isTemplateSample,
        checked,
      );
    },
    /**
     * @description Сохранить изменения пакета.
     */
    onClickSavePackage() {
      this.$emit(EMIT_CLICK_ON_SAVE_PACKAGE_BUTTON, {
        selectedTemplates: this.value,
      });
    },
  },
  props: {
    /**
     * @description Список выбранных шаблонов документов/контрактов (через v-model).
     * @type {List<SelectTemplate>}
     */
    value: {
      type: List,
      required: true,
      default: () => List(),
    },
    /**
     * @description Список категорий с шаблонами.
     * @type {List<CategoryWithTemplates>}
     */
    categoriesWithTemplates: List(),
    /**
     * @description Выбранный шаблонный Пакет на редактирование.
     * @type {Package}
     */
    selectedEditPackageTemplate: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
</style>
